import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert,
} from "@mui/material";
import { Warning as WarningIcon } from "@mui/icons-material";

const DeleteConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  title = "Confirm Deletion",
  itemType = "item",
  itemName,
  warningMessage,
  additionalInfo,
  confirmButtonText = "Delete",
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <WarningIcon sx={{ color: "error.main", fontSize: 32 }} />
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            {title}
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Alert severity="warning" sx={{ mb: 2 }}>
          This action cannot be undone
        </Alert>

        <Typography variant="body1" sx={{ mb: 2 }}>
          {warningMessage ||
            `Are you sure you want to delete this ${itemType}?`}
        </Typography>

        {itemName && (
          <Box
            sx={{
              p: 2,
              bgcolor: "grey.50",
              borderRadius: 1,
              border: "1px solid",
              borderColor: "grey.200",
            }}
          >
            <Typography variant="caption" color="text.secondary">
              {itemType.charAt(0).toUpperCase() + itemType.slice(1)}
            </Typography>
            <Typography variant="body1" sx={{ fontWeight: 600 }}>
              {itemName}
            </Typography>
          </Box>
        )}

        {additionalInfo && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
            {additionalInfo}
          </Typography>
        )}
      </DialogContent>

      <DialogActions sx={{ p: 3, gap: 1 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{ px: 3, textTransform: "none" }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          sx={{ px: 3, textTransform: "none" }}
        >
          {confirmButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmDialog;
